export default "__VITE_ASSET__YuBZ6sbo__"